module.exports = __webpack_public_path__ + "img/icon2_a.15ace72e.png";